export default __webpack_public_path__ + "static/media/school-booking-logo.862f417d.svg";